import React from 'react'
import { DefaultLayout } from '../../layouts'
import { ResourcePageHeader } from '../../components'
import { MainContent } from './components'
import { MainContentMobile } from './components/main-content-mobile'
import categories from '../../database/resource-categories.json'

const Resource = (props) => {
  const _slug = props.match.params.category
  const category = categories.find(c => c.slug === _slug) || {}

  return (
    <DefaultLayout>
      <ResourcePageHeader title={category.name} largePadding/>

      {/* MOBILE */}
      <div className="lg:hidden">
        <MainContentMobile category={category} byId={false}/>
      </div>

      {/* DESKTOP */}
      <MainContent category={category} byId={false}/>
    </DefaultLayout>
  )
}

export { Resource }